import { durationOptions, genres, regions, years } from "@/mocks/categories";
import type { VideoFilters } from "@/types";

interface FilterSidebarProps {
  filters: VideoFilters;
  onChange: (next: VideoFilters) => void;
}

interface FilterGroup {
  key: keyof VideoFilters;
  label: string;
  options: string[];
}

const groups: FilterGroup[] = [
  { key: "region", label: "地区", options: regions },
  { key: "genre", label: "类型", options: genres },
  { key: "year", label: "年份", options: years },
  { key: "duration", label: "时长", options: durationOptions },
];

export default function FilterSidebar({ filters, onChange }: FilterSidebarProps) {
  const handleSelect = (key: keyof VideoFilters, value: string) => {
    onChange({ ...filters, [key]: value });
  };

  const handleReset = () => {
    onChange({ region: "全部", genre: "全部", year: "全部", duration: "全部" });
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-filter-3-line text-lg" />
          </span>
          筛选
        </h2>
        <button
          type="button"
          onClick={handleReset}
          className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置
        </button>
      </div>

      {groups.map((group) => (
        <div key={group.key}>
          <h3 className="text-sm font-semibold text-foreground-800 mb-2.5">{group.label}</h3>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = filters[group.key] === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => handleSelect(group.key, option)}
                  className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}